import React, { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useFetch from 'use-http';
import { Loader2 } from 'lucide-react';
import {
  clearReferralVisit,
  createReferralVisitRequest,
  rememberReferralVisit,
  rememberKlinikaDoBooking,
} from '../../utils/referralTracking';

const ReferralRedirect = () => {
  const history = useHistory();
  const { search } = useLocation();
  const entryParams = useRef(new URLSearchParams(search));
  const request = useRef(null);
  const { post, response } = useFetch('/referrals/klinikaDo/visits');
  if (!request.current) {
    request.current = {
      ...createReferralVisitRequest(),
      city: entryParams.current.get('city')?.trim() || undefined,
    };
  }

  useEffect(() => {
    let active = true;
    clearReferralVisit();
    rememberKlinikaDoBooking(entryParams.current.get('email'));
    const redirect = async () => {
      try {
        const result = await post('', request.current);
        if (!active) return;
        if (response.ok && result?.visitId) {
          rememberReferralVisit(result.visitId);
          const destination = result.destinationPath;
          // Only allow the service route or the categories fallback.
          history.replace(destination === '/' || /^\/services\/\d+\/\d+\?serviceId=\d+(&cityId=\d+)?$/.test(destination)
            ? destination : '/');
          return;
        }
      } catch {
        // A tracking outage must not prevent browsing services.
      }
      if (active) history.replace('/');
    };
    redirect();
    return () => { active = false; };
  }, [history, post, response]);

  return (
    <div className="flex items-center justify-center min-h-[50vh]" role="status">
      <Loader2 className="h-5 w-5 animate-spin mr-2" />
      <span>Kraunama...</span>
    </div>
  );
};

export default ReferralRedirect;
